import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "highlightSearch",
  standalone: false,
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string, search: string): string {
    if (search !== "") {
      const valueStr = value + ""; // Ensure numeric values are converted to strings
      return valueStr.replace(
        new RegExp(
          "(?![^&;]+;)(?!<[^<>]*)(" +
            search?.trim() +
            ")(?![^<>]*>)(?![^&;]+;)",
          "gi",
        ),
        '<span class="highlight">$1</span>',
      );
    }

    return value;
  }
}
